const useActionsSelect = props => {
  const {
    agGrid,
    dataSource,
    quickEdit,
    actions
  } = props;

  // hide select if quick edit mode is active or there are no actions
  const hidden = quickEdit.active || !actions || !actions.length;

  // disable if quick edit mode is active (previous solution to hiding)
  const disabled = quickEdit.active;

  const menuOnClick = async action => {
    console.log(`Performing: ${action.key} on ${agGrid.selectedRows.length} rows`);

    action.callback(agGrid.selectedRows);
    //if (action.singleAction) {
    //  await action.callback(action.key, agGrid.selectedRows[0]);
    //} else {
    //  for (let row of agGrid.selectedRows) {
    //    await action.callback(action.key, row);
    //  }
    //}

    // temp disabling for now, might remove
    //dataSource.forceReload();
    //agGrid.refreshGrid();
  }

  return {
    hidden,
    disabled,
    menuOnClick
  }
}

export default useActionsSelect;
